/**
 * Check if the experimental chatbot is enabled.
 * Checks sessionStorage first (allowing runtime override), then falls back to env var.
 * @returns true if experimental chatbot is enabled, false otherwise
 */
export const getExperiementalChatbotEnabled = (): boolean => {
  const sessionValue = sessionStorage.getItem("experiementalChatbotEnabled");
  if (sessionValue !== null) {
    return sessionValue === "true";
  }
  return process.env.REACT_APP_EXPERIMENTAL_CHATBOT_ENABLED === "true";
};
